module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Выбор отчёта или формы","no-data":"Нет ни одного отчета или формы"},"en":{"title":"Select report or form","no-data":"No data"}}')
  delete Component.options._Ctor
}
